'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RRSS = function (_React$Component) {
	(0, _inherits3.default)(RRSS, _React$Component);

	function RRSS(props, context) {
		(0, _classCallCheck3.default)(this, RRSS);
		return (0, _possibleConstructorReturn3.default)(this, (RRSS.__proto__ || (0, _getPrototypeOf2.default)(RRSS)).call(this, props));
	}

	(0, _createClass3.default)(RRSS, [{
		key: 'openPopUp',
		value: function openPopUp(caller, el) {
			var url = '';
			var element = '';

			if (el.target.children[0]) {
				element = el.target.children[0];
			} else {
				element = el.target;
			}

			if (element.classList.contains('icon-twitter')) {
				url = 'https://twitter.com/intent/tweet?url=' + caller.props.twUrl + '&text=' + caller.props.twText;
			} else if (element.classList.contains('icon-fb')) {
				url = 'http://www.facebook.com/sharer/sharer.php?u=' + caller.props.url;
			} else if (element.classList.contains('icon-gplus')) {
				url = 'https://plus.google.com/share?url=' + caller.props.url;
			}

			caller.props.analytics ? Analytics.adobeShare() : false;

			window.open(url, "_blank", "toolbar=no, scrollbars=no, resizable=yes, top=500, left=500, width=400, height=400");
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'ul',
				{ className: "rrss" + this.props.rrssVisible },
				_react2.default.createElement(
					'li',
					{ onClick: this.openPopUp.bind(null, this) },
					_react2.default.createElement('i', { className: 'icon-fb' })
				),
				_react2.default.createElement(
					'li',
					{ onClick: this.openPopUp.bind(null, this) },
					_react2.default.createElement('i', { className: 'icon-twitter' })
				),
				_react2.default.createElement(
					'li',
					{ onClick: this.openPopUp.bind(null, this) },
					_react2.default.createElement('i', { className: 'icon-gplus' })
				)
			);
		}
	}]);
	return RRSS;
}(_react2.default.Component);

exports.default = RRSS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RRSS/RRSS.js
// module id = 804
// module chunks = 0